import { render } from "./ContactPage.vue?vue&type=template&id=dd6fbff0&scoped=true"
import script from "@/assets/js/contact.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/contact.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/contact.css?vue&type=style&index=0&id=dd6fbff0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6fbff0"]])

export default __exports__